import React from 'react';
import {isPPM, isSWSwitchIPM} from '../../utils/validate';
import {getComponentPath} from '../../utils/localStorageDataHandler';
import './gqlListContent.less';

const processTranslation = (translationString, stringToReplace) => {
    let processedString = translationString;
    stringToReplace.forEach((strings, i) => {
        processedString = processedString.replace(`{${i}}`, strings);
    });

    return processedString;
};

const processTranslationReplaceAll = (translationString, stringToReplace) => {
    if(!translationString) {
        return translationString;
    }
    let processedString = translationString;
    stringToReplace.forEach((strings, i) => {
        processedString = processedString.split(`{${i}}`).join(strings); // replace all instances of {i} with var strings
    });

    return processedString;
};

// Splits a translation on its {linkStart}/{linkEnd} markers and wraps the segment between them in a real <a> element,
// so the clickable word/phrase can vary per locale without matching on literal English text.
const renderLinkedTranslation = (translationString, href) => {
    const parts = translationString.split(/\{linkStart\}|\{linkEnd\}/);
    if (parts.length !== 3) {
        return translationString;
    }
    const [before, linkText, after] = parts;

    return [
        before,
        <a key="link" target="_blank" rel="noopener noreferrer" href={href}>{linkText}</a>,
        after
    ];
};

const getKey = (environment) => {
    let key;
    if (environment === 'development' || environment === 'test' || environment === 'stage') {
        key = '6Lc9wYgUAAAAAGO8RUMpMrrCSkPOPPnURlwEeMDp';
    } else {
        key = '6LfevogUAAAAAPYRflZ8TWtUtUp9hapFeAW4jCy9';
    }

    return key;
};

const getListContentClass = (userType) => (isPPM(userType) || isSWSwitchIPM(userType)) ? 'list-content-item' : 'dialog-box-item';

const checkLocalStateAndRedirect = (props) => {
    const path = getComponentPath(props.publicUuid);
    if (path) {
        props.actions.changeAppState(path);
    }
};

const renderBoldTextBeforeColon = (text) => {
    const colonIndex = text.indexOf(':');
    if (colonIndex !== -1) {
        return (
            <>
                <strong>{text.substring(0, colonIndex)}</strong>
                {text.substring(colonIndex)}
            </>
        );
    }
    return text
};

const ListContent = (props) => {
    const {contentList, listItemClass} = props;

    return (
        <ul>
            {
                (contentList instanceof Array)
                    ? contentList.map((item, i) => {
                        return (<li key={i} className={listItemClass}> {item} </li>);
                    })
                    : null
            }
        </ul>
    );
};

const GqlListContent = (props) => {
    const {userType, contentList, translations, listItemClass} = props
    return (
        <div>
            {userType === 'PPM' &&
                <div>
                    <ul className={'unordered-list-item'}>
                        <li>{translations['ipmob.gql.complete.dialog.list_1.content_1']}</li>
                        <li>{translations['ipmob.gql.complete.dialog.list_1.content_2']}</li>
                    </ul>
                    <p className={'heading-item'}>
                        {translations['ipmob.gql.complete.dialog.list_2.heading.1']}
                    </p>
                </div>
            }
            <ul className={'unordered-list-item'}>
                {contentList.map((item, index) => (
                    <li key={index} className={`${listItemClass} margin-bottom-item`}>
                        {/* Render parent bullet */}
                        {item.parentBullet && renderBoldTextBeforeColon(item.parentBullet)}
                        {/* Check if child bullets exist and render them */}
                        {item.childBullets && item.childBullets.length > 0 && (
                            <ul className={'unordered-list-child-item'}>
                                {item.childBullets.map((childBullet, childIndex) => (
                                    <li key={childIndex}>{childBullet}</li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    )
}

const isHelpLinkTextAvailable = (headerData) =>
    (headerData && headerData.header && headerData.header.help && (typeof headerData.header.help.items !== 'undefined' &&
        headerData.header.help.items.length > 0));

const getTaxIdentifierQuestion = (countryCode) => {
    let questionKey;
    switch (countryCode) {
        case 'FR':
            questionKey = 'ipmob.company_location.sub_heading_7';
            break;
        case 'DE':
            questionKey = 'ipmob.company_location.sub_heading_8';
            break;
        case 'PT':
            questionKey = 'ipmob.company_location.sub_heading_9';
            break;
        case 'ES':
            questionKey = 'ipmob.company_location.sub_heading_10';
            break;
        case 'GB':
            questionKey = 'ipmob.company_location.sub_heading_11';
            break;
        default:
            questionKey = 'ipmob.company_location.sub_heading_11'
            break;
    }

    return questionKey;
};

const getTaxIdentifierLabel = (countryCode) => {
    let taxIdentifierLabel;
    switch (countryCode) {
        case 'FR':
            taxIdentifierLabel = 'ipmob.company_location.label_4';
            break;
        case 'DE':
            taxIdentifierLabel = 'ipmob.company_location.label_5';
            break;
        case 'PT':
            taxIdentifierLabel = 'ipmob.company_location.label_6';
            break;
        case 'ES':
            taxIdentifierLabel = 'ipmob.company_location.label_7';
            break;
        case 'GB':
            taxIdentifierLabel = 'ipmob.company_location.label_3';
            break;
        default:
            taxIdentifierLabel = 'ipmob.company_location.label_2'
            break;
    }

    return taxIdentifierLabel;
};

const chunkArray = (array, size) => {
    let chunks = [];
    for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
    }
    return chunks;
}

export {
    processTranslation,
    processTranslationReplaceAll,
    renderLinkedTranslation,
    getKey,
    getListContentClass,
    checkLocalStateAndRedirect,
    ListContent,
    GqlListContent,
    isHelpLinkTextAvailable,
    getTaxIdentifierQuestion,
    getTaxIdentifierLabel,
    chunkArray
};
